/*
 * manual-payment-reward-simple.js
 * - Only 2 tiers:
 *   - > 0  => 1 gift
 *   - >= 1499 => 2 gifts
 * - Max 2 gifts total
 * - Always remove old gifts before new selection
 * - Uses concurrent add.js calls for speed
 */

(function () {
  if (!window.location.pathname.includes('/cart')) return;

  // --- Config ---
  const HANDLES = [
    'revolax-deep-free-gift',
    'celosome-soft-copy',
    'metox-100-units-free-gift', 
    'saline-for-botox-injection-50-in-1-free-gift',
    'j-cain-cream-10-56-500g-free-gift',
    'linetox-100u-free-gift',
    'onetox-100u-free-gift',
    'vom-m-volume-free-gift',
    'youthfill-deep-lidocaine-free-gift',
    'revolax-fine-free-gift'
  ];

  const POPUP_ID = 'manual-payment-reward-popup';
  const PRODUCT_LIST_ID = 'manual-payment-product-list';
  const MESSAGE_ID = 'manual-payment-message';
  const ADD_BTN_ID = 'manual-payment-add-button';
  const ADD_MORE_BTN_ID = 'manual-payment-add-more';
  const CANCEL_BTN_ID = 'manual-payment-cancel';
  const TIER_INFO_ID = 'manual-payment-tier-info';
  const SELECTION_INFO_ID = 'manual-payment-selection-info';

  const ADD_MORE_URL = '/collections/hot-deals-collection';

  // --- DOM refs ---
  const popup = document.getElementById(POPUP_ID);
  if (!popup) return;

  const listEl = document.getElementById(PRODUCT_LIST_ID);
  const messageEl = document.getElementById(MESSAGE_ID);
  const addButton = document.getElementById(ADD_BTN_ID);
  const addMoreBtn = document.getElementById(ADD_MORE_BTN_ID);
  const cancelBtn = document.getElementById(CANCEL_BTN_ID);
  const closeBtn = popup.querySelector('.manual-payment-popup__close');
  const tierInfoEl = document.getElementById(TIER_INFO_ID);
  const selectionInfoEl = document.getElementById(SELECTION_INFO_ID);

  // --- State ---
  let productData = [];
  let selectedVariantIds = new Set();
  let maxSelectable = 0;
  let currencySymbol = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : '';

  // --- Cart helpers ---
  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function changeCartItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    }).then(r => r.json());
  }

  async function addVariantToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: { _manual_payment_reward: true }
      })
    }).then(r => r.json());
  }

  function subtotalUnitsFromCart(cart) {
    const cents = (typeof cart.items_subtotal_price === 'number')
      ? cart.items_subtotal_price
      : cart.total_price;
    return Math.round(cents / 100);
  }

  // Only 2 tiers: >0 = 1 gift, >=1499 = 2 gifts
  function giftsAllowedForSubtotal(subtotalUnits) {
    if (subtotalUnits >= 1499) return 2;
    if (subtotalUnits > 0) return 1;
    return 0;
  }

  function isRewardLine(item) {
    return !!(item.properties && item.properties._manual_payment_reward);
  }

  async function removeAllRewardLines() {
    const cart = await getCart();
    const rewardLines = cart.items.filter(isRewardLine);
    if (!rewardLines.length) return;
    await Promise.all(rewardLines.map(item => changeCartItem(item.key, 0)));
  }

  async function ensureNoFreeGiftsWhenNoPaidItems() {
    const cart = await getCart();
    const paidItems = cart.items.filter(i => !isRewardLine(i));
    const rewardLines = cart.items.filter(isRewardLine);
    if (!paidItems.length && rewardLines.length) {
      await Promise.all(rewardLines.map(item => changeCartItem(item.key, 0)));
    }
  }

  async function updateTierDisplay() {
    const cart = await getCart();
    const subtotal = subtotalUnitsFromCart(cart);
    const allowed = giftsAllowedForSubtotal(subtotal);
    maxSelectable = allowed;

    if (tierInfoEl) {
      if (allowed === 0) {
        tierInfoEl.textContent = 'Add products to get a free gift.';
      } else if (allowed === 1) {
        tierInfoEl.textContent = 'You qualify for 1 free gift.';
      } else {
        tierInfoEl.textContent = 'You qualify for 2 free gifts.';
      }
    }
    if (selectionInfoEl) {
      selectionInfoEl.textContent = `Selected ${selectedVariantIds.size}. You can select up to ${maxSelectable}.`;
    }
  }

  function buildProducts() {
    if (!listEl) return;
    listEl.innerHTML = '';
    productData.forEach((product, index) => {
      const variant = product.variants && product.variants[0];
      if (!variant) return;

      const li = document.createElement('li');
      li.className = 'splide__slide';
      li.innerHTML = `
        <div class="manual-payment-popup__product" data-variant-id="${variant.id}">
          <div class="manual-payment-popup__product-image">
            <img src="${product.images && product.images[0] ? product.images[0] : ''}" alt="${product.title}">
          </div>
          <div class="manual-payment-popup__product-info">
            <h3 class="manual-payment-popup__product-title">${product.title}</h3>
            <div class="manual-payment-popup__price">
              <span class="current-price">${(product.price/100).toFixed(2)} ${currencySymbol}</span>
            </div>
          </div>
          <div class="manual-payment-popup__product-checkbox">
            <input class="mr-checkbox" type="checkbox" id="manual-product-${index}" value="${variant.id}">
          </div>
        </div>`;
      listEl.appendChild(li);
    });

    try {
      const splideRoot = popup.querySelector('.splide');
      if (splideRoot && typeof Splide === 'function') {
        if (splideRoot._splide && typeof splideRoot._splide.destroy === 'function') {
          splideRoot._splide.destroy();
        }
        const spl = new Splide(splideRoot, {
          perPage: 4,
          gap: '1rem',
          pagination: true,
          arrows: false,
          breakpoints: { 768: { perPage: 3 } }
        });
        spl.mount();
      }
    } catch (e) {}

    listEl.querySelectorAll('.manual-payment-popup__product').forEach(prod => {
      const cb = prod.querySelector('input[type="checkbox"]');
      if (!cb) return;

      cb.addEventListener('change', function () {
        if (this.checked) {
          if (selectedVariantIds.size >= maxSelectable) {
            this.checked = false;
            if (messageEl) {
              messageEl.textContent = `You can only select up to ${maxSelectable} gift(s).`;
              setTimeout(() => { messageEl.textContent = ''; }, 2000);
            }
            return;
          }
          selectedVariantIds.add(this.value);
          prod.classList.add('selected');
        } else {
          selectedVariantIds.delete(this.value);
          prod.classList.remove('selected');
        }
        if (selectionInfoEl) {
          selectionInfoEl.textContent = `Selected ${selectedVariantIds.size}. You can select up to ${maxSelectable}.`;
        }
      });

      prod.style.cursor = 'pointer';
      prod.addEventListener('click', function (e) {
        if (e.target.closest('input[type="checkbox"]')) return;
        const checkbox = this.querySelector('input[type="checkbox"]');
        if (!checkbox) return;
        checkbox.checked = !checkbox.checked;
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  // --- Popup ---
  async function openPopup() {
    await removeAllRewardLines();
    selectedVariantIds.clear();
    popup.classList.remove('hidden');
    popup.classList.add('show');
    document.body.classList.add('manual-payment-popup-open');
    await updateTierDisplay();
  }

  function closePopup() {
    popup.classList.add('hidden');
    popup.classList.remove('show');
    document.body.classList.remove('manual-payment-popup-open');
  }

  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  if (addMoreBtn) addMoreBtn.addEventListener('click', () => { window.location.href = ADD_MORE_URL; });
  if (cancelBtn) cancelBtn.addEventListener('click', () => { closePopup(); window.location.href = '/checkout'; });

  // --- Checkout interception (simple) ---
  function attachCheckoutInterceptors() {
    document.addEventListener('click', function (e) {
      const target = e.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]');
      if (!target) return;
      if (!window.location.pathname.includes('/cart')) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      openPopup();
    }, true);

    const cartForm = document.querySelector('form[action*="/cart"]');
    if (cartForm) {
      cartForm.addEventListener('submit', function (e) {
        try {
          if (e.submitter && e.submitter.name === 'checkout') {
            e.preventDefault();
            e.stopImmediatePropagation();
            openPopup();
          }
        } catch (err) {}
      }, true);
    }
  }

  // --- Add gifts then checkout ---
  if (addButton) {
    addButton.addEventListener('click', async function () {
      if (!selectedVariantIds.size) {
        if (messageEl) {
          messageEl.textContent = 'Please select at least one gift.';
          setTimeout(() => { messageEl.textContent = ''; }, 2000);
        }
        return;
      }
      if (selectedVariantIds.size > maxSelectable) {
        if (messageEl) {
          messageEl.textContent = `You can only select up to ${maxSelectable} gift(s).`;
          setTimeout(() => { messageEl.textContent = ''; }, 2000);
        }
        return;
      }

      addButton.disabled = true;
      try {
        await removeAllRewardLines();

        await Promise.all(
          Array.from(selectedVariantIds).map(id => addVariantToCart(id))
        );

        if (window.confetti) {
          try {
            window.confetti({
              zIndex: 9999999,
              particleCount: 150,
              spread: 70,
              origin: { y: 0.4 }
            });
          } catch (e) {}
        }

        if (messageEl) {
          messageEl.innerHTML =
            '<div class="free-offer-accepted">Your free product(s) have been added! Redirecting to checkout…</div>';
        }

        setTimeout(() => { window.location.href = '/checkout'; }, 800);
      } catch (e) {
        console.error('[ManualReward] add error', e);
        if (messageEl) {
          messageEl.textContent = 'Something went wrong. Please try again.';
        }
        addButton.disabled = false;
      }
    });
  }

  // --- Init products + minimal cleanup ---
  async function fetchProduct(handle) {
    return fetch(`/products/${handle}.js`).then(r => r.json()).catch(() => null);
  }

  async function init() {
    try {
      const results = await Promise.all(HANDLES.map(h => fetchProduct(h)));
      productData = results.filter(Boolean);
      buildProducts();
    } catch (e) {
      console.error('[ManualReward] product load', e);
    }

    // Only minimal cleanup (fast)
    await ensureNoFreeGiftsWhenNoPaidItems();
    attachCheckoutInterceptors();
    await updateTierDisplay();
  }

  init();
})();
